var _a;
import api from 'axios';
import applyCaseMiddleware from 'axios-case-converter';
import qs from 'qs';
// On API Calls:
// - Convert camelCase to snake_case for typescript -> rails standards
// - Convert arrays to compatible rails array syntax
/* eslint-disable */
const apiClient = applyCaseMiddleware(api.create({
    baseURL: window.location.origin,
    paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'brackets' });
    },
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': ((_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || ''
    }
}));
// ---------------------------------------------------------------------------
// Cross-origin override for the standalone chat widget bundle.
//
// When the widget is loaded by a non-Rails host (e.g. the Angular Technician
// Portal) `window.location.origin` is NOT the tenant's Rails origin, so the
// default `baseURL` above points at the wrong server. `configureApiClient`
// lets `mountChatWidget()` redirect every subsequent request to the correct
// tenant host AND inject `auth_token` / `username` query params on every
// request, which the Rails tech-portal endpoints already accept as an
// alternative to cookie-based session auth.
//
// Call it again with `null` baseUrl / authParams to clear. The function
// returns a restore closure that `mount.ts` wires into the widget's cleanup
// callback so a host that unmounts the widget leaves the client state as
// it found it.
// ---------------------------------------------------------------------------
let apiClientAuthParams = null;
let apiClientPathRewrites = [];
const authParamInterceptorId = apiClient.interceptors.request.use((config) => {
    var _a;
    if (apiClientAuthParams) {
        config.params = Object.assign(Object.assign({}, ((_a = config.params) !== null && _a !== void 0 ? _a : {})), apiClientAuthParams);
    }
    if (apiClientPathRewrites.length > 0 && typeof config.url === 'string') {
        for (const rewrite of apiClientPathRewrites) {
            if (config.url.startsWith(rewrite.prefix)) {
                config.url = rewrite.replacement + config.url.slice(rewrite.prefix.length);
                break;
            }
        }
    }
    return config;
});
// Hold a reference so a future test can eject the interceptor if needed.
apiClient.__authInterceptorId = authParamInterceptorId;
export function configureApiClient(options) {
    var _a, _b, _c;
    const previousBaseUrl = apiClient.defaults.baseURL;
    const previousAuthParams = apiClientAuthParams;
    const previousPathRewrites = apiClientPathRewrites;
    if (options.baseUrl !== undefined) {
        apiClient.defaults.baseURL = (_a = options.baseUrl) !== null && _a !== void 0 ? _a : window.location.origin;
    }
    if (options.authParams !== undefined) {
        apiClientAuthParams = (_b = options.authParams) !== null && _b !== void 0 ? _b : null;
    }
    if (options.pathRewrites !== undefined) {
        apiClientPathRewrites = (_c = options.pathRewrites) !== null && _c !== void 0 ? _c : [];
    }
    return function restoreApiClient() {
        apiClient.defaults.baseURL = previousBaseUrl;
        apiClientAuthParams = previousAuthParams;
        apiClientPathRewrites = previousPathRewrites;
    };
}
export default apiClient;
